/**
 * Created by user on bank bundle files implementation.
 */


class BankFileTransactionCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private documentNumberLabel:MUILabel = null;
    private descriptionLabel:MUILabel = null;
    private legalNameLabel:MUILabel = null;
    private accountLabel:MUILabel = null;
    private invoiceAmountLabel:MUILabel = null;
    private amountLabel:MUILabel = null;  
    private optionsButton:MUIButton = null;  

    private cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter as MIONumberFormatter;
    private df = MUIWebApplication.sharedInstance().delegate.dateFormatter as MIODateFormatter;

    awakeFromHTML() {
        super.awakeFromHTML();
                
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.documentNumberLabel = MUIOutlet(this, "document-number-lbl", "MUILabel");
        this.descriptionLabel = MUIOutlet(this, "description-lbl", "MUILabel");
        this.legalNameLabel = MUIOutlet(this, "legal-name-lbl", "MUILabel");
        this.accountLabel = MUIOutlet(this, "account-lbl", "MUILabel");
        this.invoiceAmountLabel = MUIOutlet(this, "invoice-amount-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.optionsButton = MUIOutlet(this, "options-btn", "MUIButton");
        this.optionsButton.setAction(this, this.showOptions);
    }

    private _item: LegalEntityPaymentInstallment = null;
    set item(item: LegalEntityPaymentInstallment) {
        this._item = item;
        
        let invoice_amount = item.invoice?.totalAmount ?? 0;

        this.dateLabel.text = this.df.stringFromDate(item.date);
        this.documentNumberLabel.text = item.documentNumber;
        this.descriptionLabel.text = item.concept;
        this.invoiceAmountLabel.text = this.cf.stringFromNumber(invoice_amount);
        this.amountLabel.text = this.cf.stringFromNumber(item.amount);

        this.updateLegalEntity();
    }

    private updateLegalEntity(){
        this.legalNameLabel.text = this._item.legalEntityName;
        let account = null;

        if (this._item.legalEntity instanceof Client) {
            account = this._item.legalEntity.salesLedgerAccount?.prefix;
        }
        else if (this._item.legalEntity instanceof Supplier) {
            account = this._item.legalEntity.purchaseLedgerAccount?.prefix;
        }

        this.accountLabel.text = account;

        this.updateColorStyle(account);
    }

    private updateColorStyle( account:LedgerAccount ){
        let invoice_amount = this._item.invoice?.totalAmount ?? 0;

        if (account == null || Math.abs(invoice_amount - this._item.amount) > 0.01) {
            MUICoreLayerAddStyle(this.dateLabel.layer, "alert");
            MUICoreLayerAddStyle(this.documentNumberLabel.layer, "alert");
            MUICoreLayerAddStyle(this.descriptionLabel.layer, "alert");
            MUICoreLayerAddStyle(this.legalNameLabel.layer, "alert");
            MUICoreLayerAddStyle(this.accountLabel.layer, "alert");
            MUICoreLayerAddStyle(this.invoiceAmountLabel.layer, "alert");
            MUICoreLayerAddStyle(this.amountLabel.layer, "alert");            
        }
        else {
            MUICoreLayerRemoveStyle(this.dateLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.documentNumberLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.descriptionLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.legalNameLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.accountLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.invoiceAmountLabel.layer, "alert");
            MUICoreLayerRemoveStyle(this.amountLabel.layer, "alert");            
        }
    }

    private showOptions() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString( "OPTIONS", "OPTIONS" ), MIOLocalizeString("SELECT_AN_OPTION", "SELECT AN OPTION"), MUIAlertViewStyle.Default );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CHANGE_INVOICE_LEGAL_ENTITY", "CHANGE INVOICE LEGAL ENTITY"), MUIAlertActionStyle.Default, this, function(this:BankFileTransactionCell){
            this.selectInvoiceLegalEntity();
        } ));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null ) );

        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    private selectInvoiceLegalEntity() {
        AppHelper.sharedInstance().showLegalEntitySelectionViewController( null, LegalEntityDefaultSelectionType.client, null, (legalEntity:LegalEntity) => {
            this.legalEntityDidSelect(legalEntity);
        } );
    }

    private legalEntityDidSelect(legalEntity:LegalEntity) {
        DBHelper.queryObjectWithCompletion( "LegalEntity", null, MIOPredicate.predicateWithFormat( "identifier == " + legalEntity.identifier ), ["salesLedgerAccount", "purchaseLedgerAccount"], this, function(this:BankFileTransactionCell, object:LegalEntity) {
            this._item.legalEntity = object;
            this._item.legalEntityName = object.name;
            this.updateLegalEntity();
            DBHelper.saveMainContext();
        });
    }
}
